// Where to go after sign-in when the sign-in was interrupting something —
// today only the OAuth consent page (an MCP client such as claude.ai sent the
// user here to connect their account).
//
// sessionStorage, not redux: social login leaves the app for the provider and
// comes back in a full page load, and the return target must survive that.

const KEY = 'm9sOAuthReturn';

// Only in-app paths, so a crafted link cannot turn sign-in into an open redirect.
// `//host` and `/\host` are both protocol-relative to a browser.
const isInternalPath = (path: string) => /^\/(?![/\\])/.test(path);

export const rememberOAuthReturn = (path: string) => {
    if (!isInternalPath(path)) {
        return;
    }
    try {
        sessionStorage.setItem(KEY, path);
    } catch (e) {
        // Storage unavailable: the user lands on the cabinet list instead.
    }
};

export const forgetOAuthReturn = () => {
    try {
        sessionStorage.removeItem(KEY);
    } catch (e) {
        // Nothing stored then either.
    }
};

export const takeOAuthReturn = (): string | null => {
    try {
        const path = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        return path !== null && isInternalPath(path) ? path : null;
    } catch (e) {
        return null;
    }
};
